import { useAppDispatch, useAppSelector } from 'store/Store';
import { setLoading, setAddresses } from 'store/ClientsSlice';
import useApiUser from 'service/apicataleg/useApiUser';

const useClient = () => {
  const dispatch = useAppDispatch();

  const clientState = useAppSelector((state) => state.client);
  const { loading, client, addresses } = clientState;

  const { api } = useApiUser();
  const refetchAddresses = () => {
    dispatch(setLoading(true));
    api.client
      .getClientAddresses()
      .then((newAddresses) => setAddresses(newAddresses))
      .finally(dispatch(setLoading(false)));
  };

  return {
    selectedClient: client,
    addresses,
    refetchAddresses,
    loading,
    hasSelectedClient: Boolean(client) && client.codi > 0,
  };
};

export default useClient;
